import sha256 from 'sha256'
export default function (password, user) {
  return sha256(sha256(password) + user)
}
